// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schedule-calendar-icon {\n  position: absolute;\n  top: 44%;\n  right: 6%;\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
